import { Component } from '@angular/core';
import {NgForOf} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-technologies',
  imports: [
    NgForOf,
    TranslatePipe
  ],
  templateUrl: './technologies.component.html',
  styleUrl: './technologies.component.scss'
})
export class TechnologiesComponent {

  public technologies = [
    {
      title: 'Front-End',
      list: ['TypeScript', 'Javascript', 'Angular', 'React', 'VueJS']
    },
    {
      title: 'Back-End',
      list: ['NodeJS', 'NestJS', 'PHP (Laravel)', 'Wordpress', 'PrestaShop', 'OpenCart']
    },
    {
      title: 'Mobile',
      list: ['React Native', 'Flutter', 'Ionic', 'Android', 'iOS', 'Objective-C', 'Swift']
    },
    {
      title: 'Databases',
      list: ['MySQL', 'PostgreSQL', 'SQLite', 'MariaDB', 'Mongo', 'DynamoDB']
    },
    {
      title: 'DevOps and Cloud',
      list: ['Amazon AWS', 'Google Cloud', 'Kubernetes', 'Docker', 'Jenkins']
    },
    ]
}
